import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const CollectionScreen = ({data}) => {
  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-5 lg:py-20 py-10 '}>
      <div className={'max-w-7xl w-full'}>
        <div className={'w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-4xl text-primary-900'}>{data.title}</h1>
          <p className={'playfair-display-medium lg:text-2xl text-lg mt-3 pb-4 '}>{data.description}</p>
        </div>
        
        <div className={'rounded-3xl'}>
          <div className={'grid lg:grid-cols-4  md:grid-cols-2 grid-cols-1 gap-5 xl:gap-10 mt-5'}  data-aos={'fade-in-up'}>
            {data.valuePillars.map((pillar, index) => (
              <div
                key={index}
                data-aos={'fade-up'}
                className={' border border-primary-100 p-2 rounded-[40px] shadow-md transform transition-all duration-300 hover:scale-105 shadow-primary-300 hover:shadow-xl'}
              >
                <Link to = {'/products'}>
                  <div
                    className={'w-full shadow-md min-h-[250px] rounded-[40px] flex flex-col justify-between bg-primary-600'}
                  >           
                    <img src={pillar.img} alt={pillar.title} className={'w-full lg:h-60 h-60 object-cover rounded-t-[40px] rounded-b-[40px]'} />
                    <h5 className={'text-xl text-white text-wrap text-center font-serif font-semibold py-1.5'}>
                      {pillar.title}
                    </h5>
                  </div>
                </Link>    
              </div> 
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

CollectionScreen.propTypes = {
  data: PropTypes.shape,
};

export default CollectionScreen;
